import { render, staticRenderFns } from "./VerifyMobileDevice.html?vue&type=template&id=bc012338&scoped=true&"
import script from "./VerifyMobileDevice.vue?vue&type=script&lang=ts&"
export * from "./VerifyMobileDevice.vue?vue&type=script&lang=ts&"
import style0 from "./VerifyMobileDevice.scss?vue&type=style&index=0&id=bc012338&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc012338",
  null
  
)

export default component.exports